import { c as _c } from "react/compiler-runtime";
import { useGSAP } from '@gsap/react';
import { RefObject } from 'react';
import { gsap } from '@/lib/gsap';
interface Params {
  wrapperRef: RefObject<HTMLDivElement | null>;
  gradientRef: RefObject<HTMLDivElement | null>;
  graffitiRef: RefObject<HTMLDivElement | null>;
  flashRef: RefObject<HTMLImageElement | null>;
  isPageReady: boolean;
}
export function useHeroParallax(t0) {
  const $ = _c(11);
  const {
    wrapperRef,
    gradientRef,
    graffitiRef,
    flashRef,
    isPageReady
  } = t0;
  let t1;
  if ($[0] !== flashRef || $[1] !== gradientRef || $[2] !== graffitiRef || $[3] !== isPageReady || $[4] !== wrapperRef) {
    t1 = () => {
      const wrapper = wrapperRef.current;
      const gradient = gradientRef.current;
      const graffiti = graffitiRef.current;
      if (!wrapper || !gradient || !graffiti || !isPageReady) {
        return;
      }
      const matchMedia = gsap.matchMedia();
      matchMedia.add({
        isDesktop: "(min-width: 992px)",
        isMobile: "(max-width: 991px)"
      }, context => {
        const {
          isDesktop
        } = context.conditions as gsap.Conditions;
        if (!isDesktop) {
          return;
        }
        const smoothGradientX = gsap.quickTo(wrapper, "--x", {
          duration: 1,
          ease: "power1.out"
        });
        const smoothGradientY = gsap.quickTo(wrapper, "--y", {
          duration: 1,
          ease: "power1.out"
        });
        const setGraffiti = gsap.quickSetter(graffiti, "css");
        let rafId = null;
        const onMove = event => {
          if (rafId) {
            return;
          }
          rafId = requestAnimationFrame(() => {
            const flash = flashRef.current;
            const {
              width,
              height,
              left,
              top
            } = graffiti.getBoundingClientRect();
            const xParallax = (event.clientX / window.innerWidth - 0.5) * 100;
            const yParallax = (event.clientY / window.innerHeight - 0.5) * 100;
            const xPerspective = ((event.clientX - left) / width - 0.5) * 6;
            const yPerspective = ((event.clientY - top) / height - 0.5) * -6;
            const xGradient = event.clientX / window.innerWidth * 100;
            const yGradient = event.clientY / window.innerHeight * 100;
            if (flash) {
              gsap.set(flash, {
                rotate: xPerspective
              });
            }
            setGraffiti({
              x: -xParallax,
              y: -yParallax,
              rotateX: yPerspective,
              rotateY: xPerspective
            });
            smoothGradientX(xGradient);
            smoothGradientY(yGradient);
            rafId = null;
          });
        };
        window.addEventListener("mousemove", onMove);
        return () => {
          window.removeEventListener("mousemove", onMove);
          if (rafId) {
            cancelAnimationFrame(rafId);
          }
        };
      });
    };
    $[0] = flashRef;
    $[1] = gradientRef;
    $[2] = graffitiRef;
    $[3] = isPageReady;
    $[4] = wrapperRef;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== isPageReady) {
    t2 = [isPageReady];
    $[6] = isPageReady;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2 || $[9] !== wrapperRef) {
    t3 = {
      scope: wrapperRef,
      dependencies: t2
    };
    $[8] = t2;
    $[9] = wrapperRef;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  useGSAP(t1, t3);
}